import React, { useContext, useMemo } from 'react';

import { cn, resultIf } from '../../../../utils';
import { SecondaryProjectContext } from '../../../../views/dashboard/lender/investment/purchase/SecondaryProjectContext/SecondaryProjectContext';
import SecondaryProjectNavigation from '../../../../views/dashboard/lender/investment/purchase/SecondaryProjectNavigation';
import { DetailedProjectContext } from '../DetailedProjectContext/DetailedProjectContext';
import DetailedProjectHtml from '../DetailedProjectHtml';
import DetailedProjectNavigation from '../DetailedProjectNavigation';
import { useMountAnimation, useWindowWidth } from '../hooks';
import ProjectDropdown from '../ProjectDropdown';

import './ProjectLegalAnalysis.scoped.scss';

const ProjectLegalAnalysis = () => {
  const project = useContext(DetailedProjectContext).project;
  const mounted = useMountAnimation();
  const isMobile = useWindowWidth();
  const offer = !!useContext(SecondaryProjectContext);
  const navigation = useMemo(() => {
    if (offer) {
      return <SecondaryProjectNavigation />;
    } else {
      return <DetailedProjectNavigation />;
    }
  }, [offer]);
  const legalInfo = useMemo(() => {
    return (
      project.information !== null && (
        <div className={cn('project-legal', resultIf(mounted, 'mounted'))}>
          <DetailedProjectHtml translations={project.information.legalContent} />
        </div>
      )
    );
  }, [mounted]);

  return (
    <div className="project-legal-container">
      {isMobile ? (
        <ProjectDropdown header="Юридический анализ">{legalInfo}</ProjectDropdown>
      ) : (
        <>
          <div className="detailed-project__header">{navigation}</div>
          <div className="detailed-project__content">{legalInfo}</div>
        </>
      )}
      <ProjectDropdown header="Обязательства должника">
        {project.information !== null && (
          <DetailedProjectHtml translations={project.information.obligationsContent} />
        )}
      </ProjectDropdown>
    </div>
  );
};

export default ProjectLegalAnalysis;
